var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-input-box-mobile"
  }, [_c('LabelMobile', {
    attrs: {
      "name": _vm.name,
      "is-required": _vm.isRequired
    }
  }), _c('div', {
    staticClass: "form-input-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.text,
      expression: "text"
    }],
    staticClass: "form-input-mobile",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value;
      }, _vm.onInputChanged]
    }
  }), _vm.validator ? _c('div', {
    staticClass: "validator-line"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.请填写必填项")) + " ")]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }